<div *ngFor="let item of items" style="width: 100%">
  <mat-card fxFlex class="list-call-item clickable">
    <mat-card-title class="list-user-item-title">
      <div class="clickable">
        <small
          ><b>#{{ item.id }}</b></small
        >
      </div>
      <div class="clickable">
        <button mat-icon-button (click)="listBusinessUsers(item.id)">
          <mat-icon>supervisor_account</mat-icon>
        </button>
        <button mat-icon-button (click)="listBusinessCalls(item.id)">
          <mat-icon>list</mat-icon>
        </button>
      </div>
    </mat-card-title>

    <div style="margin-bottom: 0">
      <div>
        <b><small>Nome:</small></b> <br />
        {{ item.name }}
      </div>
      <div>
        <b> <small>CNPJ:</small></b> <br />
        {{item?.cnpj | mask:'CPF_CNPJ'}}
      </div>
    </div>
  </mat-card>
</div>
